import { render, staticRenderFns } from "./TerminallistDet.vue?vue&type=template&id=43843012&scoped=true&"
import script from "./TerminallistDet.vue?vue&type=script&lang=js&"
export * from "./TerminallistDet.vue?vue&type=script&lang=js&"
import style0 from "./TerminallistDet.vue?vue&type=style&index=0&id=43843012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43843012",
  null
  
)

export default component.exports